import React, { Component } from 'react';
import firebase from 'firebase';
import { Grid, Row, Col, ListGroup, ListGroupItem, Badge, FormGroup, ControlLabel, FormControl, ButtonToolbar, ToggleButtonGroup, ToggleButton } from 'react-bootstrap';
//import { Bar } from 'react-chartjs';
import Loading from '../../components/Loading';
import ListUser from './ListUser';
import ListRoom from './ListRoom';
import { SECTIONS } from '../../config';
import Ranking from './Ranking';
import Activity from './Activity';

type IProps = {
  room: string,
}

type IState = {
  users: Array<Object>,
  lessons: Array<Object>,
  type: number,
  view: number,
  section: number,
  loading: boolean,
}

const types = [
  {
    id: 'list',
    title: 'List',
  },
  {
    id: 'graph',
    title: 'Graph',
  },
];

const sections = [
  {
    id: 'phrases',
    statistics: 'statistics/phrase',
    title: 'Phrases',
  },
  {
    id: 'words',
    statistics: 'statistics/vocabulary',
    title: 'Vocabulary',
  },
];

const views = [
  {
    id: 'room',
    title: 'Answers',
  },
  {
    id: 'single',
    title: 'Students',
  },
  {
    id: 'ranking',
    title: 'Ranking',
  },
  {
    id: 'activity',
    title: 'Activity',
  },
];

class Users extends Component {

  constructor() {
    super();

    this.state = {
      users: [],
      lessons: [],
      type: 0,
      section: 0,
      view: -1,
      loading: true,
    };
  }

  state: IState;

  componentDidMount() {
    const { room } = this.props;

    firebase.database()
    .ref('users')
    .orderByChild(`rooms/${room}`)
    .equalTo(true)
    .on('value', (snapshot) => {
      const users = snapshot.val() || {};

      const usersInArray = [];
      Object.keys(users).forEach(key => usersInArray.push(users[key]));
      const sortedUsers = usersInArray.sort((a, b) => a.name < b.name ? -1 : 1);

      this.setState({
        users: sortedUsers,
        loading: false,
      });
    });

    firebase.database()
    .ref(`room/${room}/lessons`)
    .on('value', (snapshot) => {
      this.setState({
        lessons: snapshot.val(),
        loading: false,
      });
    });
  }
  
  handleChangeType(type: number) {
    this.setState({
      type,
    });
  }
  
  handleChangeSection(e) {
    this.setState({
      section: e.target.value,
    });
  }
  
  handleChangeView(view: number) {
    this.setState({
      view,
    });
  }

  props: IProps;

  render() {
    if (this.state.loading) return <Loading />;
    
    const { room } = this.props;
    const { users, lessons } = this.state;
    const { type, view, section } = this.state;

    if (users.length === 0) {
      return (
        <Grid>
          <Row style={{ marginBottom: '30px' }}>
            <Col xs={12}>
              <h1>Statistics</h1>
            </Col>
          </Row>
          <p>No students yet</p>
        </Grid>
      );
    }

    return (
      <Grid>
        <Row style={{ marginBottom: '30px' }}>
          <Col xs={12}>
            <h1>Statistics</h1>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={6} md={4}>
            <ButtonToolbar>
              <ToggleButtonGroup type="radio" name="view" defaultValue={view} onChange={(value) => { this.handleChangeView(value); }}>
                {
                  views.map((view, index) => <ToggleButton key={view.id} value={index}>{view.title}</ToggleButton>)
                }
              </ToggleButtonGroup>
            </ButtonToolbar>
          </Col>
              {/*
          <Col xs={12} sm={6} md={4}>
            <ControlLabel>Type</ControlLabel>
            <ButtonToolbar>
              <ToggleButtonGroup type="radio" name="type" defaultValue={type} onChange={(value) => { this.handleChangeType(value); }}>
                {
                  types.map((type, index) => <ToggleButton key={type.id} value={type.id}>{type.title}</ToggleButton>)
                }
              </ToggleButtonGroup>
            </ButtonToolbar>
          </Col>*/}
          <Col xs={12} sm={6} md={4}>
            <FormGroup controlId="section">
              <FormControl componentClass="select" placeholder="Select Section" defaultValue={section} onChange={(e) => { this.handleChangeSection(e); }}>
                {
                  sections.map((section, index) => <option key={section.id} value={index}>{section.title}</option>)
                }
              </FormControl>
            </FormGroup>
          </Col>
        </Row>
        {
          type === 0 && view === 0 && <ListRoom lessons={lessons} room={room} users={users} section={sections[section]} />
        }
        {
          type === 0 && view === 1 && <ListUser lessons={lessons} room={room} users={users} section={sections[section]} />
        }
        {
          type === 0 && view === 2 && <Ranking lessons={lessons} room={room} users={users} section={sections[section]} />
        }
        {
          type === 0 && view === 3 && <Activity lessons={lessons} room={room} users={users} section={sections[section]} />
        }
        {
          Object.keys(users).length === 0 && <p>No users in your room.</p>
        }
      </Grid>
    );
  }
}

export default Users;



// WEBPACK FOOTER //
// ./src/pages/Statistics/index.js